var _g, _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcFtm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 68,
    viewBox: "0 0 58 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_4596_14696)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5726 28.2479L34.5279 23.0656L36.4552 30.2582L29.5726 28.2479ZM39.6214 42.0746L33.0142 48.9843L23.8374 46.3039L21.5889 37.9126L30.7658 40.593L37.3729 33.6833L39.6214 42.0746ZM18.7439 27.2949L25.6266 29.3052L20.6712 34.4875L18.7439 27.2949ZM29.0449 30.2248L35.9276 32.2351L30.9722 37.4173L29.0449 30.2248ZM28.9992 37.946L22.1165 35.9357L27.0719 30.7534L28.9992 37.946ZM33.0826 21.6174L27.2784 27.5778L19.2716 25.3181L25.0299 19.1865L33.0826 21.6174ZM16.1285 25.4261L22.1397 47.8601L33.5648 51.0393L41.8697 42.5734L35.8585 20.1394L24.4334 16.9602L16.1285 25.4261Z",
    fill: "url(#paint0_linear_4596_14696)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5726 28.2479L34.5279 23.0656L36.4552 30.2582L29.5726 28.2479ZM39.6214 42.0746L33.0142 48.9843L23.8374 46.3039L21.5889 37.9126L30.7658 40.593L37.3729 33.6833L39.6214 42.0746ZM18.7439 27.2949L25.6266 29.3052L20.6712 34.4875L18.7439 27.2949ZM29.0449 30.2248L35.9276 32.2351L30.9722 37.4173L29.0449 30.2248ZM28.9992 37.946L22.1165 35.9357L27.0719 30.7534L28.9992 37.946ZM33.0826 21.6174L27.2784 27.5778L19.2716 25.3181L25.0299 19.1865L33.0826 21.6174ZM16.1285 25.4261L22.1397 47.8601L33.5648 51.0393L41.8697 42.5734L35.8585 20.1394L24.4334 16.9602L16.1285 25.4261Z",
    fill: "url(#paint1_linear_4596_14696)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4596_14696",
    x: 0.128906,
    y: 0.960205,
    width: 57.7402,
    height: 66.0791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_4596_14696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4596_14696",
    x1: 24.4334,
    y1: 16.9602,
    x2: 33.5648,
    y2: 51.0393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7F5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AD5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4596_14696",
    x1: 24.4334,
    y1: 16.9602,
    x2: 33.5648,
    y2: 51.0393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7F5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AD5FF"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFtm);
export default __webpack_public_path__ + "static/media/ic_ftm.ef3578adee0f2d754c21dfe2ef8a3d71.svg";
export { ForwardRef as ReactComponent };